import { useFormContext } from 'react-hook-form'

type Props = {
  name: string
}
export const AuthoritySelector = (props: Props): JSX.Element => {
  const { name } = props
  const { register } = useFormContext()

  const authorityList = [
    { key: 'ADMIN', value: '管理者' },
    { key: 'GENERAL', value: '一般' }
  ]
  return (
    <div>
      <label className={'text-gray-600'}>{'管理者権限'}</label>
      <select
        className={
          'w-full rounded-sm p-1 text-sm outline-none bg-gray-100'
        }
        {...register(name)}
      >
        {authorityList.map((data) => (
          <option value={data.key} key={data.key}>
            {data.value}
          </option>
        ))}
      </select>
    </div>
  )
}
